import {
  Card,
  CardHeader,
  CardFooter,
  Table,
  Container,
  Row,
  Button,
} from "reactstrap";
import Header from "components/Headers/Header.js";
import { useCallback, useEffect, useState } from "react";
import moment from "moment";
import Pagination from "components/Pagination";
import { getNewsLetterList } from "services/_newsLetter";
import { useNavigate } from "react-router-dom";
import { getPermissions } from "context/AuthContext";

const NewsLetter = () => {
  const permissions = getPermissions();
  const [newsLetterData, setNewsLetterData] = useState([]);
  const [records, setRecords] = useState([]);
  const [page, setPage] = useState(1);
  const [perPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const navigate = useNavigate();

  const initialData = useCallback(async () => {
    let payload = `page=${page}&per_page=${perPage}`;

    const data = await getNewsLetterList(payload);
    if (data.data) {
      setRecords(data.data.records || []);
      setNewsLetterData(data.data.records);
      setTotalRecords(data.data.total_records || 0);
      if (data.data.total_records && perPage) {
        setTotalPages(Math.ceil(data.data.total_records / perPage));
      }
    }
  }, [page, perPage]);

  useEffect(() => {
    initialData();
  }, [initialData]);

  const prevButton = async () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };

  const nextButton = async () => {
    if (totalPages > page) {
      setPage(page + 1);
    }
  };

  const handleSendmail = () => {
    navigate("/admin/sendmail");
  };

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between">
                <h3>Newsletter </h3>
                {permissions.includes("send-email") && (
                  <Button color="info" onClick={handleSendmail}>
                    Send Mail
                  </Button>
                )}
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Email</th>
                    <th scope="col">Created At</th>
                  </tr>
                </thead>
                <tbody>
                  {newsLetterData.length > 0 ? (
                    newsLetterData.map((user, index) => {
                      return (
                        <>
                          <tr key={index}>
                            <th scope="row">
                              {(page - 1) * perPage + index + 1}
                            </th>
                            <td>{user.email}</td>
                            <td>
                              {user.created_at
                                ? moment(user.created_at).format(
                                    "DD MMMM, YYYY"
                                  )
                                : "-"}
                            </td>
                          </tr>
                        </>
                      );
                    })
                  ) : (
                    <tr>
                      <td>No record found</td>
                    </tr>
                  )}
                </tbody>
              </Table>
              <CardFooter className="py-4">
                <Pagination
                  page={page}
                  perPage={perPage}
                  totalRecords={totalRecords}
                  totalPages={totalPages}
                  records={records}
                  prevButton={prevButton}
                  nextButton={nextButton}
                />
              </CardFooter>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default NewsLetter;
